import { mergeStyles, PrimaryButton, Stack, useTheme } from '@fluentui/react';
import {
  CheckmarkCircle24Filled,
  CheckmarkCircle24Regular,
} from '@fluentui/react-icons';
import React, { useState } from 'react';
import { MobileDatePicker } from '../Datepicker/MobileDatePicker';
import { BaseComponentProps, Input } from '../types';
import { checkListStyles } from './CheckListStyles';

interface CheckListProps extends BaseComponentProps {
  editable?: boolean;
  title?: string;
}

const nameStyle = mergeStyles({
  flexGrow: 1,
});

export const CheckList = (props: CheckListProps): JSX.Element => {
  const { inputs, editable, title, onSubmit } = props;
  const [checkedInputs, setCheckedInputs] = useState<Array<Input>>([]);
  const [inputValues, setInputValues] = useState<Array<Input>>(inputs);

  const theme = useTheme();
  const styles = checkListStyles(theme);

  const handleClick = (input: Input) => {
    const updatedCheckedInputs = checkedInputs.includes(input)
      ? checkedInputs.filter((checkedInput) => checkedInput !== input)
      : checkedInputs.concat(input);
    setCheckedInputs(updatedCheckedInputs);
  };

  const defaultOnChange = (key: string, value: string) => {
    for (let i = 0; i < inputValues.length; i++) {
      if (inputValues[i].key === key) {
        inputValues[i].value = value;
      }
    }
    setInputValues(inputValues);
  };

  const handleSubmit = () => {
    console.log(checkedInputs);
    console.log(inputValues);
    onSubmit && onSubmit(checkedInputs);
  };

  return (
    <Stack styles={{ root: styles.containerRoot }}>
      {title ? (
        <Stack styles={{ root: styles.headingContainerRoot }}>
          <p className={mergeStyles(styles.heading)}>{title}</p>
        </Stack>
      ) : null}
      <ul className={mergeStyles(styles.ul)}>
        {inputs.map((input) => {
          const checkMark = checkedInputs.includes(input);
          return (
            <span key={input.id}>
              {editable ? (
                <li className={mergeStyles(styles.li)}>
                  <Stack horizontal>
                    <Stack style={{ width: '100%' }}>
                      {input.type === 'date' ? (
                        <MobileDatePicker
                          defaultValue={
                            input.value ? new Date(input.value) : undefined
                          }
                          placeholder={input.name}
                          onChange={(value) => {
                            defaultOnChange(
                              input.key,
                              value.toLocaleDateString()
                            );
                          }}
                        />
                      ) : (
                        <input
                          className={mergeStyles(styles.inputField)}
                          type={input.type}
                          name={input.name}
                          defaultValue={input.value}
                          placeholder={input.name}
                          disabled={checkMark ? true : false}
                          onChange={(value) => {
                            defaultOnChange(input.key, value.target.value);
                          }}
                        />
                      )}
                    </Stack>
                    {input.type === 'checkbox' && (
                      <Stack verticalAlign="center">
                        <label style={{ fontSize: '14px', paddingLeft: '4px' }}>
                          {input.name}
                        </label>
                      </Stack>
                    )}
                  </Stack>
                  {/* {checkMark ? (
                    <CheckmarkCircle24Filled />
                  ) : (
                    <CheckmarkCircle24Regular />
                  )} */}
                </li>
              ) : (
                <li
                  className={mergeStyles(styles.li)}
                  onClick={() => handleClick(input)}
                >
                  <span className={nameStyle}>{input.name}</span>
                  {checkMark ? (
                    <CheckmarkCircle24Filled />
                  ) : (
                    <CheckmarkCircle24Regular />
                  )}

                  {/* <img
                    src={checkMark ? CheckCircle : CheckCircleGrey}
                    className={mergeStyles(styles.checkIcon)}
                  /> */}
                </li>
              )}
            </span>
          );
        })}
      </ul>
      <Stack>
        <PrimaryButton
          className={mergeStyles(styles.button)}
          text="SUBMIT"
          onClick={() => handleSubmit()}
        />
      </Stack>
    </Stack>
  );
};
